import { isEmail, isEmpty } from 'ts-utils';
import { RegistrationNewUserDetails } from '../store/user/effects/RegisterUser';
import { AuthError, BasicLoginDetails, LoginDetails } from './Auth';

const NO_FILL_ERROR: AuthError = {
  code: 'auth/no-fill-error',
  message: "Please make sure you've correctly filled in all fields.",
};

export const NON_MATCHING_EMAIL_ERROR: AuthError = {
  code: 'auth/non-matching-email',
  message: 'Emails do not match. Please make sure you have entered the same email in both fields.',
};

const INVALID_EMAIL_RESET_ERROR: AuthError = {
  code: 'auth/invalid-email-reset',
  message: 'Please enter a valid email address.',
};

function validateLogin(details: Partial<LoginDetails>): details is LoginDetails {
  if ('token' in details) {
    if (typeof details.token !== 'string') {
      throw NO_FILL_ERROR;
    }
  } else {
    validateBasicLogin(details as Partial<BasicLoginDetails>);
  }
  return true;
}

function validateBasicLogin(details: Partial<BasicLoginDetails>) {
  if (!isEmail(details.email) || isEmpty(details.password)) {
    throw NO_FILL_ERROR;
  }
}

function validateRegistration(
  details: RegistrationNewUserDetails
): details is RegistrationNewUserDetails {
  validateBasicLogin(details);
  validateMatchingEmails(details);
  if (isEmpty(details.name) || isEmpty(details.lastName)) {
    throw NO_FILL_ERROR;
  }
  return true;
}

/**
 * As of March 2024, we require users to confirm their email, so there are both
 *  `confirmEmail` and `email` fields, and they must match.
 */
function validateMatchingEmails(details: RegistrationNewUserDetails): void {
  if (details.confirmEmail.trim() !== details.email.trim()) {
    throw NON_MATCHING_EMAIL_ERROR;
  }
}

function validateResetPassword(email: string): void {
  if (!isEmail(email)) {
    throw INVALID_EMAIL_RESET_ERROR;
  }
}

export const AuthValidation = {
  validateLogin,
  validateRegistration,
  validateResetPassword,
};
